/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetMostRecentlyViewedOptions, GetMostRecentlyViewedResponses } from '../../models/GetMostRecentlyViewed'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Most Recently Viewed
 * {@link /courses/most-recently-viewed}
 */
export function getMostRecentlyViewed<ThrowOnError extends boolean = true>(options: Options<GetMostRecentlyViewedOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetMostRecentlyViewedResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/courses/most-recently-viewed', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetMostRecentlyViewedResponses, ThrowOnError>>
}
